// const ApexCharts = require('apexcharts');
import moment from 'moment';
import Api from './Api';
import MinerRigsTable from './components/MinerRigsTable.mjs';
import HashrateChart from './components/HashrateChart.mjs';
import LastSharesCard from './components/LastSharesCard.mjs';
import MinerJobsCard from './components/MinerJobsCard.mjs';
import MinerLastBlockAndSubmits from './components/MinerLastBlockAndSubmits.mjs';
import { parseUnits, submitsToHashrate } from './utils';
import { createModalApp } from './components/StartMiningModal.mjs';
import { openModal } from './modal';
import { createApp } from './components/HeaderBar.mjs';

let activeMiners = 0;
let hashrate60M = 0;
let hashrate5M = 0;
let lastSubmitDate = new Date('2000-01-01');
let rigsTable = null;
let jobsCard = null;
let chainStats = null;

export default async function run(wallet, coin = 'bch') {
    rigsTable = new MinerRigsTable(document.querySelector('.rigs-table'), coin);
    jobsCard = new MinerJobsCard(document.querySelector('.miner-jobs-card'));
    const ch1 = new LastSharesCard(document.querySelector("#bestshare-chart"), coin, wallet);
    const ch2 = new HashrateChart(document.querySelector("#hashrate-chart"), coin, wallet);

    const blocks = new MinerLastBlockAndSubmits(document.querySelector(".miner-blocks"), wallet, coin);

    document.querySelector('a.start-mining-btn').addEventListener('click', (e) => {
        e.preventDefault();
        openModal('#start-mining-modal');
    });
    createModalApp('#start-mining-modal', coin, wallet);

    createApp('header.navbar');

    try {
        updateGeneratedWork(wallet, coin);
        setInterval(() => updateGeneratedWork(wallet, coin), 15 * 1000);
        await ch1.render();
        await ch2.render();

    } catch (error) {
        
    }
}

async function updateGeneratedWork(wallet, coin = 'bch') {

    try {
        chainStats = await Api.mine.stats(coin);
        document.querySelector('.network-diff').innerHTML = parseUnits(chainStats.difficulty, '');
        document.querySelector('.network-hashrate').innerHTML = parseUnits(chainStats.networkhashps);
    } catch (error) {
        console.warn("Cant load stats");
    }

    try {
        let jobs = await Api.miner.jobs(coin, wallet);
        jobsCard.render(jobs && jobs.length > 0 ? jobs[0] : null, chainStats);
    } catch (error) {
        console.warn("Cant load stats");
    }

    try {
        const res = await Api.miner.generatedWork(coin, wallet, 'from_last_block');
        let workGenerated = 0;
        for (const rig in res) {
            workGenerated += res[rig].work;
            const lastSubDate = new Date(res[rig].lastSubmit);
            if (lastSubDate > lastSubmitDate) lastSubmitDate = lastSubDate;
        }

        let html = `${parseUnits(workGenerated, '')}`;
        if (chainStats) {
            html += ` (${Math.round(workGenerated/chainStats.difficulty * 100000)/1000}%)`;
        }
        document.querySelector('.work-generated').innerHTML = html;
    } catch (error) {
        console.warn("Cant load work");
    }

    try {
        const MIN = 60;
        const res60 = await Api.miner.generatedWork(coin, wallet, MIN);
        rigsTable.render(res60);

        let shares = 0;
        activeMiners = Object.keys(res60).length;
        for (const rig in res60) {
            shares += res60[rig].work;
        }

        let tmpHashrate = submitsToHashrate(shares, MIN * 60);
        // if (coin == 'rvn') tmpHashrate = tmpHashrate / 256;
        hashrate60M = parseUnits(tmpHashrate);

        const res5M = await Api.miner.generatedWork(coin, wallet);

        shares = 0;
        for (const rig in res5M) {
            shares += res5M[rig].work;
        }

        tmpHashrate = submitsToHashrate(shares, 300);
        // if (coin == 'rvn') tmpHashrate = tmpHashrate / 256;
        hashrate5M = parseUnits(tmpHashrate);

        document.querySelector('.miner-hashrate-60m').innerHTML = hashrate60M;
        document.querySelector('.miner-hashrate-5m').innerHTML = hashrate5M;

        document.querySelector('.coin-summary-line').innerHTML = 
            `<ul class="list-inline list-inline-dots mb-0">
                <li class="list-inline-item"><span class="text-${ activeMiners > 0 ? 'green' : 'red'}">${ activeMiners > 0 ? (activeMiners + ' active miners') : 'Nobody is mining at this moment'}</span></li>
                <li class="list-inline-item">Last submit seen: ${ moment(lastSubmitDate).from() }</li>
            </ul>`
    } catch (error) {
        console.warn("Cant load stats", error);
    }
}
